<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chaptitlef" id="photo"><a id="page_viii"></a><span class="ts2">Photograph Sources</span></h2>
<p class="noindent"><span class="dropcap">A</span>ll photographs are via the author. The publishers and the author are particularly indebted to Tim and Preston Isaac, the proprietors of the Cobbaton Combat Collection, for generously making their Czech-built T-54 available for a detailed photo shoot. The author is also grateful to Dan Reoch of D&amp;B Militaria for supplying samples of inert former warsaw Pact T-54/55 tank rounds and training rounds.</p>
<p class="indent">Photos of preserved Chinese tanks in the Beijing Military Museum were taken by Max Smith. Graham Thompson also ably assisted with photos of the Polish-built version. Max Smith and Gerry van Tonder provided shots of the Czech armoured recovery version. Vasco Barbic kindly offered guidance on the Egyptian tanks. This book would be much poorer without their assistance and expertise. Any errors though are solely the author’s</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_photo.vue?3a85cb68